import Zoom from 'react-medium-image-zoom'
import Slideshow from '../components/slideshow'
import { useTranslation, Trans } from 'react-i18next';

import Collapse from '../components/collapse'

import compositing from "../assets/img/postprod/compositing/compositing.png"
import renderParam from "../assets/img/postprod/scene_param/renderParam.png"
import premiere from "../assets/img/postprod/thumbnail/premiere.png"
import intro from "../assets/img/postprod/thumbnail/ae_timeline.png"

export default function Postproduction() {

  const { t, i18n } = useTranslation();

  return (
    <div className="row main-row">
      <div className="column column-75 column-offset-10 container">
        <div className="row section">
          <div className="column column-25">
            <h1><span className="bold">POSTPRODUCTION</span></h1>
          </div>
        </div>
        <div className="row section capsule">
          <div className="column column-25"> </div>
          <div className="column column-offset-10">
            <p>
              <Trans i18nKey="description.postprod">
              </Trans>
            </p>
          </div>
        </div>

        <Collapse
          name={"Compositing"}
        >
          <div className="row section capsule">
            <div className="column column-25"></div>
            <div className="column column-offset-10">
              <p>
                <Trans i18nKey="description.compositing">
                </Trans>
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=dZ36etj39Ko" target="blank">Blender - Render Separate Grease Pencil / Ink Layer Pass</a>
                </em></p>
              </blockquote>
              <div className="row images">
                <Zoom>
                  <img src={compositing} alt="compositing"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.didPost1">
                  </Trans>
                </p>
              </div>
            </div>
          </div>
        </Collapse>

        <Collapse
          name={"Rendering"}
        >
          <div className="row section capsule">
            <div className="column column-25"></div>
            <div className="column column-offset-10">
              <p>
                <Trans
                  i18nKey="description.rendering1"
                  components={{ italics: <span classNameName="italics" /> }}
                />
              </p>

              <div className="row images">
                <Zoom>
                  <img src={renderParam} alt="Render param01"></img>
                </Zoom>
              </div>
              <p>
                <Trans i18nKey="description.didPost2">
                </Trans>
              </p>
              <p>
                <Trans
                  i18nKey="description.rendering2"
                  components={{ italics: <span classNameName="italics" /> }}
                />
              </p>
              <p>
                <Trans i18nKey="description.rendering3">
                </Trans>
              </p>
            </div>
          </div>
        </Collapse>

        <Collapse
          name={<Trans i18nKey="description.editingTitle">
          </Trans>}
        >
          <div className="row section capsule">
            <div className="column column-25"></div>
            <div className="column column-offset-10">

              <p>
                <Trans i18nKey="description.editing">
                </Trans>
              </p>

              <blockquote>
                <p><em><span className="bold">Sound sources:</span>
                  <br /><a href="https://www.youtube.com/watch?v=CAjtimRClYU" target="blank">Geinoh Yamashirogumi - Kaneda (Akira - Original Motion Picture Soundtrack)
                  </a>
                  <br /><a href="https://www.youtube.com/watch?v=9tBHsSD0GAk&t=253s" target="blank">Akira - Biker Gang Fight Scene [4K]
                  </a>
                </em></p>
              </blockquote>

              <div className="row images">
                <Zoom>
                  <img src={premiere} alt="Timeline premiere"></img>
                </Zoom>
              </div>
              <p>
                <Trans i18nKey="description.didPost3">
                </Trans>
              </p>
              <div className="row images">
                <Zoom>
                  <img src={intro} alt="Screen Ae intro"></img>
                </Zoom>
              </div>
              <p>
                <Trans i18nKey="description.didPost4">
                </Trans>
              </p>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  )
}